import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "./toastify.css";

createRoot(document.getElementById("root")).render(<App />);
